import React from 'react'
import { Button } from 'antd'
import cn from 'classnames'

import imgLogo from 'assets/spiffme_600px.png'
import './styles.css'

const Header = ({ onSignIn, onSignUp, transparent }) => {
  return (
    <header className={cn('header', { 'header--transparent': transparent })}>
      <img className="img-logo" src={imgLogo} alt="Logo" />
      <div className="buttons">
        <Button className="button" ghost onClick={onSignIn}>Sign In</Button>
        <Button className="button" type="primary" onClick={onSignUp}>Sign Up</Button>
      </div>
    </header>
  )
}

export default Header